import { Crop } from 'react-image-crop';
import { FileWithPreview } from '@tock/coretypes';
import AppConstants from 'constants/AppConstants';

export function uploadImage(file: FileWithPreview, crop?: Crop): ApiAction {
  let apiPath = '/image/upload';
  if (crop) {
    const { x, y, width, height } = crop;
    apiPath = apiPath + `?x=${x}&y=${y}&width=${width}&height=${height}`;
  }
  return {
    TockApi: {
      postFile: apiPath,
      request: file,
      type: AppConstants.IMAGE_UPLOAD,
    },
  };
}
